import React from "react";

interface Props {
    height?: string;
    width?: string;
}

export const ApLogoMini: React.FC<Props> = (props: Props) => {
    const { height, width } = props;
    return (
        <svg
            width={height ?? "24"}
            height={width ?? "23"}
            viewBox="0 0 24 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M22.4336 4.64608L15.3186 0.43508C13.2301 -0.800993 10.6195 0.743644 10.6195 3.21761V3.6496C10.6195 4.03984 10.823 4.40104 11.1522 4.59525L12.4956 5.39026C12.8903 5.62441 13.3823 5.33218 13.3823 4.8657V3.79117C13.3823 3.25391 13.9487 2.91812 14.4018 3.18675L20.5646 6.83507C21.0177 7.1037 21.0177 7.77529 20.5646 8.0421L14.4018 11.6904C13.9487 11.9591 13.3823 11.6233 13.3823 11.086V10.5142C13.3823 8.04029 10.7717 6.49383 8.68142 7.73172L1.56637 11.9427C-0.522124 13.1788 -0.522124 16.2717 1.56637 17.5078L8.68142 21.7188C10.7699 22.9548 13.3823 21.4102 13.3823 18.9362V18.5043C13.3823 18.114 13.1788 17.7546 12.8495 17.5586L11.5062 16.7618C11.1115 16.5276 10.6195 16.8199 10.6195 17.2863V18.3609C10.6195 18.8981 10.0531 19.2339 9.6 18.9653L3.43716 15.317C2.98407 15.0483 2.98407 14.3767 3.43716 14.1081L9.6 10.4598C10.0531 10.1912 10.6195 10.527 10.6195 11.0642V11.636C10.6195 14.1099 13.2301 15.6564 15.3186 14.4185L22.4336 10.2075C24.5221 8.97505 24.5221 5.88215 22.4336 4.64608Z"
                fill="black"
            />
        </svg>
    );
};
